import React from 'react'
import { Container, Row } from 'react-bootstrap'
import PageHeader from '../layouts/PageHeader'
import Project from '../layouts/Project'
import SectionComposition from '../layouts/SectionComposition'
import { ProjectData } from '../data/ProjectData'
import PageTitle from '../hooks/PageTitle'

const Projects = () => {
  return (
    <>
        <PageTitle title="Projects"/>
         <PageHeader headerTitle="Projects"/>
            {/* Project Section Start */}
            <SectionComposition bgColor="off-white">
                <Container fluid>
                    <Container>
                        <Row className="g-4">
                            {
                                ProjectData.map( (item, index) => {
                                    return <Project key={index} title={item.title} img={item.img} link={item.link} />
                                })
                            }
                           
                        </Row>
                    </Container>
                </Container>

           </SectionComposition>
        {/* Project Section End */}
    </>
  )
}

export default Projects